import React from 'react';
const NAVIGATION_SKELETON_CLASSES = 'loading-skeleton rounded-pill';
function NavigationSkeleton() {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                width: '100%',
            }}
        >
            <div
                className={'d-flex justify-content-start gap-3 align-items-center w-100'}>
                <div>
                    {/* Search within */}
                    <div
                        className={'loading-skeleton'}
                        style={{ width: '260px' }}
                    />
                </div>
                <div>
                    {/* Sort by */}
                    <div
                        className={NAVIGATION_SKELETON_CLASSES}
                        style={{
                            width: '130px',
                            height: '30px',
                            marginLeft: 'auto',
                        }}
                    />
                </div>
                <div>
                    {/* Default page size */}
                    <div
                        className={NAVIGATION_SKELETON_CLASSES}
                        style={{
                            width: '120px',
                            height: '30px',
                            marginLeft: 'auto',
                        }}
                    />
                </div>
            </div>
            <div
                className={'d-flex justify-content-between align-items-center w-full'}>
                <div>
                    {/* Search result details */}
                    <div
                        className={'loading-skeleton'}
                        style={{ width: '260px' }}
                    />
                </div>
                <div>
                    {/* Next button */}
                    <div
                        className={NAVIGATION_SKELETON_CLASSES}
                        style={{
                            width: '70px',
                            height: '30px',
                            marginLeft: 'auto',
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

export default NavigationSkeleton;